import { getEnterpriseTag } from 'src/services/config';
import {
  getCreateSceneType,
  getDeptList,
  getFormType,
  getOperatorSceneTypeList,
  getSceneTypeList,
  getWebForm,
  getWebFormAudit,
  getWebFormCashier,
  getWebFormFinance,
  getWebFormOperate,
  getWebFormPurchase,
  getWebFormReimburse,
  getWebFormTenant,
  queryAttachmentList,
  queryScenarioTypeList,
} from '../services';

export default {
  namespace: 'allList',
  state: {
    modelLoading: false,
    // 单据类型枚举
    formTypeList: [],
    // 场景类型枚举
    sceneTypeList: [],
    // 部门列表
    deptList: [],
    // 收入管理Detail
    incomeDetail: {},
    // 待处理审批的参数（用于连续审批功能使用）
    currentParams: {},
  },
  effects: {
    // 获取企业标识
    *getEnterpriseTag({ payload }, { call, put }) {
      const result = yield call(getEnterpriseTag, payload);

      return result;
    },
    // 获取单据类型
    *getFormType({ payload }, { call, put }) {
      const result = yield call(getFormType, payload);
      yield put({
        type: 'update',
        payload: {
          formTypeList: result || [],
        },
      });
      return result;
    },

    // 获取场景类型下拉
    *getSceneTypeList({ payload }, { call, put }) {
      const result = yield call(getSceneTypeList, payload);
      yield put({
        type: 'update',
        payload: {
          sceneTypeList: result || [],
        },
      });
      return result;
    },
    // todo 临时写法， 回单关联报销单过滤场景类型, 后续版本会统一使用getSceneTypeList
    *getSceneTypeListBySpec({ payload }, { call, put }) {
      const result = yield call(getSceneTypeList, payload);
      const limitScene = [
        'TRAVEL',
        'MEETING',
        'RECEPTION',
        'TRAIN',
        'P_OFFICE',
        'P_GENERAL',
        'P_GOV',
        'P_FURNITURE',
        'GENERAL',
        'REST_FORM',
        'ORG_FUND_INCOME',
      ];
      const newResult = result?.filter(i => limitScene.includes(i.definition));
      yield put({
        type: 'update',
        payload: {
          sceneTypeList: newResult || [],
        },
      });
      return newResult;
    },
    // 运营侧-获取场景类型下拉
    *getOperatorSceneTypeList({ payload }, { call, put }) {
      if (!payload?.orgIdList?.length) return;
      const result = yield call(getOperatorSceneTypeList, payload);
      yield put({
        type: 'update',
        payload: {
          sceneTypeList: result || [],
        },
      });
      return result;
    },

    // 获取可创建场景类型
    *getCreateSceneType({ payload }, { call }) {
      const result = yield call(getCreateSceneType, payload);
      return result;
    },

    // 获取单据列表
    *getWebForm({ payload }, { call }) {
      yield new Promise(resolve => {
        setTimeout(resolve, 1500);
      });
      const result = yield call(getWebForm, payload);
      result.uid = payload.uid;
      return result;
    },
    // 获取单据列表
    *getWebFormPurchase({ payload }, { call }) {
      yield new Promise(resolve => {
        setTimeout(resolve, 1500);
      });
      const result = yield call(getWebFormPurchase, payload);
      result.uid = payload.uid;
      return result;
    },

    // 获取审核列表
    *getWebFormAudit({ payload }, { call, put }) {
      yield new Promise(resolve => {
        setTimeout(resolve, 1500);
      });
      const result = yield call(getWebFormAudit, payload);
      // 只在审批在待处理阶段存储参数
      if (payload.tagType === 3) {
        yield put({
          type: 'update',
          payload: {
            currentParams: payload,
          },
        });
      }
      result.uid = payload.uid;
      return result;
    },

    // 获取下一个审核
    *getNextApprover({ payload }, { call, select }) {
      const params = yield select(state => state.allList.currentParams);
      const currentFormCode = payload.currentFormCode;
      const res = yield call(getWebFormAudit, {
        ...params,
        // 多取一个，避免是当页的最后一个审批
        pageSize: params.pageSize + 1,
      });
      if (res) {
        const { data, total } = res;
        if (!data.length || data[data.length - 1]?.formCode === currentFormCode) return;
        const currentIndex = data.findIndex(i => i.formCode === currentFormCode);
        const nextApprover = data[currentIndex + 1];
        return {
          nextApprover,
          total,
        };
      }
    },

    // 获取财务列表
    *getWebFormFinance({ payload }, { call }) {
      yield new Promise(resolve => {
        setTimeout(resolve, 1500);
      });
      const result = yield call(getWebFormFinance, payload);
      result.uid = payload.uid;
      return result;
    },

    // 获取出纳列表
    *getWebFormCashier({ payload }, { call }) {
      yield new Promise(resolve => {
        setTimeout(resolve, 1500);
      });
      const result = yield call(getWebFormCashier, payload);
      result.uid = payload.uid;
      return result;
    },

    // 获取运营列表
    *getWebFormOperate({ payload }, { call }) {
      yield new Promise(resolve => {
        setTimeout(resolve, 1500);
      });
      const result = yield call(getWebFormOperate, payload);
      result.uid = payload.uid;
      return result;
    },

    // 获取部门列表
    *getDeptList({ payload }, { call, put }) {
      const result = yield call(getDeptList, payload);
      if (result?.departmentInfoDtoList?.length) {
        yield put({
          type: 'update',
          payload: {
            deptList: result.departmentInfoDtoList || [],
          },
        });
      }
    },
    // 获取归档打印列表
    *getWebFormReimburse({ payload }, { call }) {
      yield new Promise(resolve => {
        setTimeout(resolve, 1500);
      });
      const result = yield call(getWebFormReimburse, payload);
      result.uid = payload.uid;
      return result;
    },
    // 获取附件信息
    *queryAttachmentList({ payload }, { call }) {
      const result = yield call(queryAttachmentList, payload);
      return result;
    },
    // 获取场景类型
    *queryScenarioTypeList({ payload }, { call }) {
      const result = yield call(queryScenarioTypeList, payload);
      return result;
    },
    // 获取租户列表
    *getWebFormTenant({ payload }, { call }) {
      const result = yield call(getWebFormTenant, payload);
      result.uid = payload.uid;
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
